import React from 'react';
import { IProps } from './types';
// import moment from 'moment';
import moment from 'moment-timezone';
import { Marriage } from 'constants/enums/marriage.enum';
import commonService from 'utils/commonService';
import { PolicyBaseItemOptContent, PolicyItemListContent, ConstrainContent, CriteriaContent } from 'bff/models/product/vehicleItemList';
import _ from 'lodash';
import { VehicleItemType } from 'constants/enums/vehicleItemType';
import service from 'bff/services/carProductService';
import { VehicleAdd } from 'bff/models/product';
import { IVehicleOwnerInfoFormValue, IVehicleOwnerInfoState } from 'constants/models/components/insureProcessCar/vehicleOwnerInfo';
import { InsureProcessFillState, InsureProcessFillFormValue } from 'constants/models/components/insureProcessCar/insureProcessFill';
import { InprocessSelectState, InprocessSelectFormValue } from 'constants/models/components/insureProcessCar/inprocessSelect';
import { IVehicleInfoFormValue, IVehicleInfoState } from 'constants/models/components/insureProcessCar/vehicleInfo';
import { InsType } from 'constants/enums/insType.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import environment from 'constants/environments';
import { NationalType } from 'constants/enums/nationalType.enum';
import { IVehiclePreviewFormValue, IVehiclePreviewState } from 'constants/models/components/insureProcessCar/vehiclePreview';
import { Link } from 'bff/models/link';
import { Formik, Form } from 'formik';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import apiCommonService from 'bff/services/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import { ApplyType } from 'constants/enums/applyType.enum';

const initFormVal: IVehiclePreviewFormValue = {
  CONTRACTS: new Array(0),
  ALL_CONTRACT_CHECKED: false
};

let formInitialValues = initFormVal;

class InsureProcessPreview extends React.Component<IProps, IVehiclePreviewState> {
  private formikRef = React.createRef() as any;

  state: IVehiclePreviewState = {
    docLinks: new Array(0),
    termStatus: new Array(0)
  }

  componentDidMount = async () => {
    commonService.scrollToTop();

    const { tempPreviewFormValue, tempPreviewState } = this.props.tempPreview;
    if (tempPreviewFormValue && tempPreviewState) {
      formInitialValues = {
        ...formInitialValues,
        ...tempPreviewFormValue
      };

      this.setState({
        ...tempPreviewState
      });

      return;
    }

    const docLinks = await service.fetchDocLinks(this.props.insTypeId);
    if (!docLinks) return;

    const contracts = this.handleGetContracts(docLinks);

    formInitialValues = {
      ...formInitialValues,
      CONTRACTS: contracts
    };

    this.setState({
      docLinks: docLinks,
      termStatus: commonService.getInitTermStatus(contracts)
    });
    // console.log('temp State', JSON.stringify(this.props.tempState));
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;
    this.props.onUnmount(formVal, this.state);

    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 取得要保人聲明事項初始值
  */
  handleGetContracts = (contractLinks: Link[]) => {
    const res = new Array(0);
    if (contractLinks && contractLinks.length > 0) {
      _.forEach(contractLinks, (contractLink: Link, index: number) => {
        res.push({
          LINK_NAME: contractLink.NAME,
          LINK_URL: contractLink.URL,
          CONTRACT: false
        });
      });
    }
    return res;
  }

  /**
   * @description 根據路徑下載檔案
   */
  handleDownloadFile = (event: React.MouseEvent<HTMLButtonElement>, linkUrl: string, fileName: string) => {
    event.stopPropagation();
    try {
      commonService.downloadFile(linkUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  }

  /**
   * @description 設置 Contract checked time 欄位值
   */
  setContractCheckedTimeFieldValue = (event: React.MouseEvent<HTMLInputElement>, index: number) => {
    if (event.currentTarget.checked) {
      apiCommonService.fetchSysTime().then((res: any) => {
        this.formikRef.current.setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, res);
      });
    }

    if (!event.currentTarget.checked) {
      this.formikRef.current.setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, null);
      this.formikRef.current.setFieldValue('ALL_CONTRACT_CHECKED', false);
      this.formikRef.current.setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
    }

    // 更新條款狀態
    this.setState({
      termStatus: commonService.updateTermStatus(event.currentTarget.checked, index, this.state.termStatus)
    });
  }

  /**
   * @description 保障項目限制內容設定
   */
  handleItemConstrain = (constrain?: ConstrainContent, fidType?: string, item?: any, selevtVal?: any) => {
    if (!constrain) return '';

    if (constrain.CRITERIA) {
      const vehicleInfoFormValue = { ...this.props.tempVehicleInfo.tempVehicleInfoFormValue } as IVehicleInfoFormValue;
      // const diffYear = moment().diff(moment(vehicleInfoFormValue.MANUFACTUR_YEAR_MONTH), 'y');
      const diffYear = moment().year() - moment(vehicleInfoFormValue.MANUFACTUR_YEAR_MONTH).year();

      let res = '';

      let criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear < criteria.MAX && !criteria.MIN && criteria.ACTION === 'INVISIBLE');
      if (criteria) {
        res = criteria.ACTION;
      }

      criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear >= criteria.MIN && diffYear < criteria.MAX && criteria.ACTION === 'ALERT');
      if (criteria) {
        res = criteria.TEXT;
      }

      criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear >= criteria.MIN && !criteria.MAX && criteria.ACTION === 'ALERT');
      if (criteria) {
        res = criteria.TEXT;
      }

      return res;
    }

    return '';
  }

  /**
   * @description 點選下一步 Click 方法
  */
  handlePreviewSubmit = async (values: IVehiclePreviewFormValue) => {
    if (this.props.tempState.tempFill.tempFillState.applyType === ApplyType.WebRequire) {
      const isConfirm = await sweetAlertService.modal({
        title: commonService.getCodeMsg(this.props.tempState.UICodes, CodeId.W200),
        html: commonService.getCodeMsg(this.props.tempState.UICodes, CodeId.W201),
        confirmButtonText: '同意',
        cancelButtonText: '不同意',
        showCancelButton: true
      });

      if (isConfirm.dismiss) return;
    }

    const vehicleOwnerInfoFormVal = this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue as IVehicleOwnerInfoFormValue;
    const vehicleOwnerInfoState = this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState as IVehicleOwnerInfoState;
    const vehicleInfoFormVal = this.props.tempVehicleInfo.tempVehicleInfoFormValue as IVehicleInfoFormValue;
    const vehicleInfoState = this.props.tempVehicleInfo.tempVehicleInfoState as IVehicleInfoState;
    const fillState = this.props.tempFill.tempFillState as InsureProcessFillState;
    const fillFormVal = this.props.tempFill.tempFillFormValue as InsureProcessFillFormValue;
    const selectState = this.props.tempSelect.tempSelectState as InprocessSelectState;
    const selectFormVal = this.props.tempSelect.tempSelectFormValue as InprocessSelectFormValue;
    let renewal = vehicleInfoState.renewVehicle;

    const insuredYear = selectFormVal.COMPULSORY_INS_YEAR ? +selectFormVal.COMPULSORY_INS_YEAR : 1;
    let insuredPolicys = this.handleFetchInsuredPolicys(selectFormVal.POLICY_ITEM);
    insuredPolicys = this.handleUpdateSubItemOpt(insuredPolicys);

    // 取得投保項目的對應生效日
    const compulsoryStartDate = this.handleGetStartDate(selectFormVal.COMPULSORY_INS_EFFECTIVE_DATE, insuredPolicys, true);
    const arbitraryStartDate = this.handleGetStartDate(selectFormVal.ARBITRARY_INS_EFFECTIVE_DATE, insuredPolicys, false);

    // 是否包含車體險項目
    const hasDamageItem = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.ITEM_TYPE === VehicleItemType.ITEM_TYPE_BD) !== -1 ? 'Y' : 'N';

    // 是否包含竊盜險項目
    const hasThiefItem = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.ITEM_TYPE === VehicleItemType.ITEM_TYPE_TF) !== -1 ? 'Y' : 'N';

    // 過濾商品條件為 Invisible 的商品
    insuredPolicys = insuredPolicys.filter((item) => this.handleItemConstrain(item.CONSTRAIN) !== 'INVISIBLE');

    let programId = this.props.insTypeId === InsType.Car
      ? storageService.getItem(storageKeys.CarProgramCode)
      : storageService.getItem(storageKeys.MotoProgramCode);

    if (!programId) {
      programId = environment.defaultProgramId;
    }

    const memberId = storageService.getItem(storageKeys.MemberId);

    if (memberId && !renewal) {
      const renewalRes = await service.renewalVehicle(this.props.insTypeId, memberId, `${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_FRONT}-${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_BACK}`, null);
      renewal = renewalRes.RENEWAL;
    }

    console.log(renewal, renewal && renewal.Ipolicy ? renewal.Ipolicy : '')

    // 說明：改以規則處理車體險/竊盜險保額。(2024/07/31)
    const hiddenRule = commonService.getFrontendRule('88C_SERIES_ITEM_HIDDEN');
    const bdItems = hiddenRule ? hiddenRule.mainItems : [];
    const channelId = storageService.getItem(storageKeys.ChannelId);
    const serverTimeMs = await apiCommonService.fetchSysTime();
    const policyAddReq: VehicleAdd = {
      CHANNEL_ID: channelId || null,
      INS_TYPE_ID: this.props.insTypeId,
      PROD_ID: this.props.tempSelect.tempSelectState?.activeProdId || '',
      BC_TYPE: fillState.applyType || '',
      APPLY_TIME: commonService.formatUtcTime(serverTimeMs).format('YYYY-MM-DD HH:mm:ss.SSS'),
      AGREE_TIME_SDATEMOD: selectFormVal.COMPULSORY_INS_EFFECTIVE_DATE_CHECK_TIME
        ? commonService.formatUtcTime(selectFormVal.COMPULSORY_INS_EFFECTIVE_DATE_CHECK_TIME).format('YYYY/MM/DD HH:mm:ss.SSS')
        : '',
      APPLY_NO: fillState.serialNo || '',
      POLICY_NO: '',
      PLAN_ID: selectState.activePlan || '',
      AGREE_TIME_TERMS: commonService.formatUtcTime(vehicleOwnerInfoFormVal?.ALL_CONTRACT_CHECKED_TIME).format('YYYY-MM-DD HH:mm:ss.SSS'),
      // AGREE_TIME_TERMS2: commonService.formatUtcTime(values.ALL_CONTRACT_CHECKED_TIME).format('YYYY-MM-DD HH:mm:ss.SSS'),
      AGREE_TIME_TERMS2: commonService.formatUtcTime(vehicleOwnerInfoFormVal?.ALL_CONTRACT_CHECKED_TIME).format('YYYY-MM-DD HH:mm:ss.SSS'),
      COMPULSORY_SDATE: compulsoryStartDate
        ? moment(compulsoryStartDate).format('YYYYMMDD')
        : '',
      VOLUNTARY_SDATE: arbitraryStartDate
        ? moment(arbitraryStartDate).format('YYYYMMDD')
        : '',
      COMPULSORY_EDATE: compulsoryStartDate
        ? moment(compulsoryStartDate).add(insuredYear, 'y').format('YYYYMMDD')
        : '',
      VOLUNTARY_EDATE: arbitraryStartDate
        ? moment(arbitraryStartDate).add(insuredYear, 'y').format('YYYYMMDD')
        : '',
      TOTAL_FEE: commonService.getVehiclePrenium(selectState.evalCarRes.SUMPREMIUM[0].SUMPREMIUM, selectState.evalCarRes.SUMPREMIUM[0].SUMPREMIUMCI),
      TOTAL_FEE_DISCOUNT: commonService.getVehiclePrenium(selectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, selectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI),
      SUMPREMIUM: selectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUM,
      SUMPREMIUMCI: selectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI,
      POLICY_DELIVERY: fillFormVal.DELIVERY || '',
      // 固定帶 0
      PAYMENT_STATUS: '0',
      POLICY_STATUS: '0',
      LIA_UPLOAD_STATUS: '0',
      PROGRAM_ID: programId,
      IPOLICY: renewal && renewal.Ipolicy ? renewal.Ipolicy : '',
      OPERATOR: vehicleOwnerInfoFormVal.PROGRAM_ID,
      VEHICLE: {
        VEHICLECAT_ID: vehicleOwnerInfoFormVal.VEHICLE_TYPE || '',
        CAR_LICENSE: `${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_FRONT}-${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_BACK}`,
        CAR_BRAND_CODE: vehicleInfoState.activeBrand,
        HAS_DAMAGE_ITEM: hasDamageItem,
        HAS_THIEFING_ITEM: hasThiefItem,
        MANUFACTURE: moment(vehicleInfoFormVal.MANUFACTUR_YEAR_MONTH).format('YYYYMM'),
        ISSUE_DATE: vehicleInfoFormVal.ORIGINAL_DATE_ISSUE,
        DISPLACEMENT: vehicleInfoFormVal.ENGINE_DISPLACEMENT ? +vehicleInfoFormVal.ENGINE_DISPLACEMENT : 0,
        DISPLACEMENT_UNIT: vehicleInfoFormVal.ENGINE_DISPLACEMENT_UNIT,
        REPLACEMENT_PRICE: selectState.replacementPrice ? +selectState.replacementPrice : 0,
        QPT: +vehicleInfoFormVal.LIMIT,
        ENGINE_ID: selectFormVal.ENGINE_NUMBER ? selectFormVal.ENGINE_NUMBER.replace(/\s/g, '') : '',
        VEHICLE_ID: selectFormVal.VEHICAL_BODY_NUMBER ? selectFormVal.VEHICAL_BODY_NUMBER.replace(/\s/g, '') : '',
        CONCAR_CODE: vehicleInfoFormVal.VEHICAL_MODEL ? vehicleInfoFormVal.VEHICAL_MODEL.split(',') : [vehicleInfoState.activeBrand, '00', '00', '00'],
        COMPULSORY_EXP_STATUS: vehicleOwnerInfoState.policyPeriodRes.COMPULSORY_EXP_STATUS,
        VOLUNTARY_EXP_STATUS: vehicleOwnerInfoState.policyPeriodRes.VOLUNTARY_EXP_STATUS,
        REQUIRE_CAR_SURVEY: selectState.validVehicleInsRuleRes.REQUIRE_CAR_SURVEY
      },
      INSURED: {
        ID_TYPE: fillFormVal.INSURED_NATIONALITY_TYPE,
        NAME: fillFormVal.INSURED_NAME,
        ID: fillFormVal.INSURED_MEMBER_ID,
        BIRTHDAY: fillFormVal.INSURED_BIRTHDAY
          ? moment(fillFormVal.INSURED_BIRTHDAY).format('YYYYMMDD')
          : moment().format('YYYYMMDD'),
        MOBILE: fillFormVal.INSURED_MOBILE,
        EMAIL: fillFormVal.INSURED_EMAIL,
        POSTCODE: fillFormVal.INSURED_POST_CODE,
        CITY_ID: fillFormVal.INSURED_CITY_ID,
        AREA_ID: fillFormVal.INSURED_AREA_ID,
        ADDRESS: fillFormVal.INSURED_ADDRESS,
        MARRIAGE: fillFormVal.INSURED_MARRIAGE
      },
      APPLICANT: {
        TYPE: fillFormVal.POLICYHOLDER_RELATION,
        ID_TYPE: fillFormVal.POLICYHOLDER_NATIONALITY_TYPE,
        NAME: fillFormVal.POLICYHOLDER_NAME,
        ID: fillFormVal.POLICYHOLDER_MEMBER_ID,
        BIRTHDAY: fillFormVal.POLICYHOLDER_BIRTHDAY
          ? moment(fillFormVal.POLICYHOLDER_BIRTHDAY).format('YYYYMMDD')
          : moment().format('YYYYMMDD'),
        MOBILE: fillFormVal.POLICYHOLDER_MOBILE,
        EMAIL: fillFormVal.POLICYHOLDER_EMAIL,
        POSTCODE: fillFormVal.POLICYHOLDER_POST_CODE,
        CITY_ID: fillFormVal.POLICYHOLDER_CITY_ID,
        AREA_ID: fillFormVal.POLICYHOLDER_AREA_ID,
        ADDRESS: fillFormVal.POLICYHOLDER_ADDRESS,
        MARRIAGE: fillFormVal.POLICYHOLDER_MARRIAGE,
        SYNC_MBDATA: fillFormVal.UPDATE_INFO_CHECKED
      },
      ITEM_LIST: _.map(insuredPolicys, (inusredItem: any) => {
        let medical = 0;
        let life = 0;
        let factor = 0;
        let amt = 0;
        let deductible = 0;

        _.forEach(inusredItem.ITEM_OPTION, (opt: any) => {
          switch (opt.FID) {
            case VehicleItemType.ITEM_FID_MEDICAL:
              medical = +opt.SELECT_VALUE;
              break;
            case VehicleItemType.ITEM_FID_LIFE:
              life = +opt.SELECT_VALUE;
              break;
            case VehicleItemType.ITEM_FID_FACTOR:
              factor = +opt.SELECT_VALUE;
              break;
            case VehicleItemType.ITEM_FID_AMOUNT:
              amt = +opt.SELECT_VALUE;
              break;
            case VehicleItemType.ITEM_FID_DEDUCTIBLE:
              deductible = +opt.SELECT_VALUE;
              break;
          }
        });

        return {
          ITEM_TYPE: inusredItem.ITEM_TYPE,
          ITEM_ID: inusredItem.ITEM.ITEM_ID,
          CONTRACT_TYPE: inusredItem.ITEM.CONTRACT_TYPE,
          ITEM_OPTION: {
            MEDICAL: medical,
            LIFE: life,
            FACTOR: factor,
            AMOUNT: bdItems.indexOf(inusredItem.ITEM.ITEM_ID) !== -1 ? selectState.depreciateAmt : amt,
            ITEM_DEDUCTIBLE: deductible,
            FIXED_FEE: inusredItem.ITEM.RULEPREMIUM && inusredItem.ITEM.RULEPREMIUM.indexOf(',') !== -1
              ? +inusredItem.ITEM.RULEPREMIUM.replace(',', '')
              : +inusredItem.ITEM.RULEPREMIUM,
            FEE_AFTER_DISCOUNT: inusredItem.ITEM.PREMIUM && inusredItem.ITEM.PREMIUM.indexOf(',') !== -1
              ? +inusredItem.ITEM.PREMIUM.replace(',', '')
              : +inusredItem.ITEM.PREMIUM
          }
        };
      })
    };
    // const res = await service.addVehicle(policyAddReq);
    // if (!res) return;

    this.props.onPreviewSubmit(values, this.state, policyAddReq);
  }

  /**
  * @description 更新附加條款 ItemOpt 內容
 */
  handleUpdateSubItemOpt = (insuredPolicys: any) => {
    const targetItems = _.filter(insuredPolicys, (policy: any) => policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_MAIN || policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_SUB);
    const resArray = new Array(0);
    _.forEach(insuredPolicys, (policy: any) => {
      // 若為主約或副約不做任何動作
      if (policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_MAIN || policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_SUB) {
        resArray.push(policy);
      } else {
        // 若為附加條款，篩選對應的主、附約，來更新 ITEM_OPTION
        const item = _.find(targetItems, (target: any) => policy.ITEM_ID.indexOf(target.ITEM_ID) !== -1);
        if (item) {
          const res = {
            ...policy,
            ITEM_OPTION: [...item.ITEM_OPTION]
          };
          resArray.push(res);
        } else {
          resArray.push(policy);
        }
      }
    });

    return resArray;
  }

  /**
   * @description 取得投保項目的對應預定生效日期
  */
  handleGetStartDate = (date: any, insuredItems: any, isCompulsory: boolean) => {
    // VehicleItemType
    let targetItems = [...insuredItems];
    if (isCompulsory) {
      targetItems = _.filter(targetItems, (item: any) => item.CV_TYPE === VehicleItemType.CV_TYPE_CI);
    } else {
      targetItems = _.filter(targetItems, (item: any) => item.CV_TYPE === VehicleItemType.CV_TYPE_VI);
    }

    if (targetItems.length > 0) return date;

    return '';
  }

  /**
   * @description 取得有投保的保障內容資料
  */
  handleFetchInsuredPolicys = (policyItemList: PolicyItemListContent[]) => {
    const insuredPolicy = new Array(0);

    _.forEach(policyItemList, (policyItem: PolicyItemListContent) => {
      _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
        if (mainItem.CHECKED) {
          insuredPolicy.push({
            ...mainItem,
            ITEM: mainItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });

      _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
        if (subItem.CHECKED) {
          insuredPolicy.push({
            ...subItem,
            ITEM: subItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });
    });

    return insuredPolicy;
  }

  /**
   * @description 格式化顯示保障內容
  */
  handleFormatPolicyContent = (item: any) => {
    let str = `${item.ITEM_ID}.${item.ITEM_NAME}`;

    _.forEach(item.ITEM_OPTION, (opt: any) => {
      switch (opt.TYPE) {
        case VehicleItemType.ITEM_OPTION_TEXT:
        case VehicleItemType.ITEM_OPTION_CALCULATE:
          str = `${str}${opt.VALUE}`;
          break;
        case VehicleItemType.ITEM_OPTION_OPTION:
          str = `${str}${opt.SELECT_TEXT}`;
          break;
        case VehicleItemType.ITEM_OPTION_SUM: {
          str = `${str}${this.handleGetPolicyContentSumVal(item.ITEM_OPTION)}`;
          break;
        }
      }
    });

    str = `${str}${this.handleFormatContent(item)}`;

    return str;
  }

  /**
   * @description 格式化顯示內容
   */
  handleFormatContent = (item: any) => {
    const { tempSelectState } = this.props.tempSelect;
    if (!tempSelectState) return '';

    // 取得顯示折舊金額文字
    const hiddenRule = commonService.getFrontendRule('88C_SERIES_ITEM_HIDDEN');
    const mainItems = hiddenRule ? hiddenRule.mainItems : [];
    if (mainItems.indexOf(item.ITEM_ID) !== -1 && tempSelectState.depreciateAmt) {
      return `，車輛保險金額:${tempSelectState.depreciateAmt}`;
    }

    if (item.ITEM_ID === '33A' || item.ITEM_ID === '33B') {
      const opt: any = _.find(item.ITEM_OPTION, (opt: any) => opt.SELECT_VALUE);
      if (!opt) return '';

      if (isNaN(+opt.SELECT_VALUE)) return '';

      const sum = +opt.SELECT_VALUE * 2;

      return ` ${sum} 元`;
    }

    return '';
  }

  /**
   * @description 取得保障內容顯示文字用總保額
   */
  handleGetPolicyContentSumVal = (opts: PolicyBaseItemOptContent[]) => {
    const { tempVehicleInfoFormValue } = this.props.tempVehicleInfo;
    if (!tempVehicleInfoFormValue) return '';

    const opt: any = _.find(opts, (opt: PolicyBaseItemOptContent) => opt.FID === VehicleItemType.ITEM_FID_AMOUNT);
    if (!opt) return '';

    if (isNaN(+opt.SELECT_VALUE)) return '';

    const sum = (+tempVehicleInfoFormValue.LIMIT - 1) * +opt.SELECT_VALUE;
    const res = sum >= 10000 ? `${sum / 10000} 萬` : `${sum}`;

    return res;
  }

  /**
   * @description 計算特定商品 (父商品與子商品) 原始保費加總
   */
  handleCalcTargetParentProdAndChildProdRulePremiumTotal = (childProdId: string, childProdPremium: string) => {
    const hiddenRule = commonService.getFrontendRule('88C_SERIES_ITEM_HIDDEN');
    if (!hiddenRule) return;
    // 說明：改以規則處理車體險/竊盜險原始保費加總。(2024/07/31)
    const parentProdIds = hiddenRule.mapping.filter(it => it.additionalId === childProdId).map(it => it.mainId);
    if (parentProdIds.length === 0) return;
    let parentProdRulePremiumElem: HTMLElement | undefined;
    parentProdIds.forEach(prodId => {
      const elem = document.querySelector(`#prod-id-${prodId}-rule-premium`) as HTMLElement;
      if (elem) parentProdRulePremiumElem = elem;
    });
    if (!parentProdRulePremiumElem) return;
    const parentProdRulePremium = parentProdRulePremiumElem.dataset.originalPremium?.replace(',', '') ?? '';
    const childProdRulePremium = childProdPremium;
    const premiumTotal = (parentProdRulePremium.includes('-') || childProdRulePremium.includes('-')) ? '-' : commonService.thousandFormat(String(+parentProdRulePremium + +childProdRulePremium));
    parentProdRulePremiumElem.textContent = premiumTotal;
  }

  /**
   * @description 計算特定商品 (父商品與子商品) 優惠保費加總
   */
  handleCalcTargetParentProdAndChildProdPremiumTotal = (childProdId: string, childProdPremium: string) => {
    const hiddenRule = commonService.getFrontendRule('88C_SERIES_ITEM_HIDDEN');
    if (!hiddenRule) return;
    // 說明：改以規則處理車體險/竊盜險優惠保費加總。(2024/07/31)
    const parentProdIds = hiddenRule.mapping.filter(it => it.additionalId === childProdId).map(it => it.mainId);
    if (parentProdIds.length === 0) return;
    let parentProdRulePremiumElem: HTMLElement | undefined;
    parentProdIds.forEach(prodId => {
      const elem = document.querySelector(`#prod-id-${prodId}-premium`) as HTMLElement;
      if (elem) parentProdRulePremiumElem = elem;
    });
    if (!parentProdRulePremiumElem) return;
    const parentProdRulePremium = parentProdRulePremiumElem.dataset.originalPremium?.replace(',', '') ?? '';
    const childProdRulePremium = childProdPremium;
    const premiumTotal = (parentProdRulePremium.includes('-') || childProdRulePremium.includes('-')) ? '-' : commonService.thousandFormat(String(+parentProdRulePremium + +childProdRulePremium));
    parentProdRulePremiumElem.textContent = premiumTotal;
  }

  /**
   * @description 建立保障範圍
  */
  handleCreatePolicyItem = (policyItemList: PolicyItemListContent[]) => {
    const insuredPolicys = this.handleFetchInsuredPolicys(policyItemList);
    const insuredPolicysFilter = insuredPolicys.filter((item) => this.handleItemConstrain(item.CONSTRAIN) !== 'INVISIBLE'); // 過濾商品條件為 Invisible 的商品

    return _.map(insuredPolicysFilter, (policy: any, index: number) => {
      // 說明：判斷商品 ID 為 88C1、88C5、88C7、17C 則隱藏商品項目，並且與對應的父商品的「原始保費」、「優惠保費」做加總。
      const hiddenRule = commonService.getFrontendRule('88C_SERIES_ITEM_HIDDEN');
      const additionalTerms = hiddenRule ? hiddenRule.additionalTerms : [];
      const isTargetChildProdHidden = additionalTerms.includes(policy.ITEM_ID);
      if (isTargetChildProdHidden) {
        this.handleCalcTargetParentProdAndChildProdRulePremiumTotal(policy.ITEM_ID, policy.ITEM.RULEPREMIUM);
        this.handleCalcTargetParentProdAndChildProdPremiumTotal(policy.ITEM_ID, policy.ITEM.PREMIUM);
      }
      // ::: End
      return (
        <tr style={{ display: isTargetChildProdHidden ? 'none' : 'table-row' }} key={index}>
          <th className="coverage__table-x-title">{this.handleFormatPolicyContent(policy.ITEM)}</th>
          <td id={`prod-id-${policy.ITEM_ID}-rule-premium`} data-original-premium={policy.ITEM.RULEPREMIUM}>{policy.ITEM.RULEPREMIUM}</td>
          <td id={`prod-id-${policy.ITEM_ID}-premium`} data-original-premium={policy.ITEM.PREMIUM}>{policy.ITEM.PREMIUM}</td>
        </tr>
      );
    });
  }

  render () {
    /**
    * @description 取得會員 ID 類別對應的顯示名稱
   */
    const handleGetMemberIdType = (nationalityType: string) => {
      switch (nationalityType) {
        case NationalType.Foreigner:
          return '居留證號';
        case NationalType.Legal:
          return '統一編號';
        case NationalType.National:
        default:
          return '身份證字號';
      }
    };

    /**
    * @description 取得生日 類別對應的顯示名稱
   */
    const handleGetBirthdayType = (nationalityType: string) => {
      switch (nationalityType) {
        case NationalType.National:
        case NationalType.Foreigner:
        default:
          return '生日';
        case NationalType.Legal:
          return '公司登記日期';
      }
    };

    /**
     * @description 依投保項目產生對應的投保日期顯示區塊
    */
    const handleGetInsuredDateInfo = () => {
      const { tempSelectFormValue } = this.props.tempSelect;
      if (!tempSelectFormValue) return;

      const insuredPolicys = this.handleFetchInsuredPolicys(tempSelectFormValue.POLICY_ITEM);

      const resArray = new Array(0);

      // 是否包含強制險項目
      const hasCompulsory = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
        insuredPolicy.CV_TYPE === VehicleItemType.CV_TYPE_CI) !== -1;

      // 強制險投保年期
      const compulsoryInsYear = tempSelectFormValue.COMPULSORY_INS_YEAR ? tempSelectFormValue.COMPULSORY_INS_YEAR : '1';

      if (hasCompulsory) {
        resArray.push(
          <p key={0}>
            {
              `強制險預定生效日：${moment(tempSelectFormValue.COMPULSORY_INS_EFFECTIVE_DATE).format('YYYY年MM月DD日')}中午12時起，保期${compulsoryInsYear === '1' ? '一' : '二'}年`
            }
          </p>
        );
      }

      // 是否包含任意險項目
      const hasArbitrary = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
        insuredPolicy.CV_TYPE === VehicleItemType.CV_TYPE_VI) !== -1;

      // const checkarbitraryItems = ['47', '49', '58'];
      // if (!hasArbitrary) {
      //   hasArbitrary = _.findIndex(insuredPolicys, (insuredPolicy:any) =>
      //     insuredPolicy.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO && checkarbitraryItems.indexOf(insuredPolicy.ITEM_ID) !== -1) !== -1;
      // }

      if (hasArbitrary) {
        resArray.push(
          <p key={1}>
            {
              `任意險預定生效日：${moment(tempSelectFormValue.ARBITRARY_INS_EFFECTIVE_DATE).format('YYYY年MM月DD日')}中午12時起，保期${compulsoryInsYear === '1' ? '一' : '二'}年`
            }
          </p>
        );
      }

      return resArray;
    };

    return (
      <div className="insure-process-preview">
        <Formik
          initialValues={formInitialValues}
          onSubmit={this.handlePreviewSubmit}
          innerRef={this.formikRef}
          enableReinitialize
        >
          {
            ({ values, setFieldValue }) => (
              <Form>
                <div className="insure-process-preview__content">
                  {/* 保障範圍 */}
                  {
                    this.props.tempSelect && this.props.tempSelect.tempSelectFormValue && this.props.tempSelect.tempSelectState && (
                      <div className="coverage">
                        <div className="coverage__title">保障範圍</div>
                        <div className="coverage__content">
                          <div className="coverage__table">
                            <table>
                              <tbody>
                                <tr>
                                  <th className="coverage__table-y-title">保障內容</th>
                                  <th className="coverage__table-y-title">原始保費</th>
                                  <th className="coverage__table-y-title">優惠保費</th>
                                </tr>
                                {
                                  this.handleCreatePolicyItem(this.props.tempSelect.tempSelectFormValue.POLICY_ITEM)
                                }
                              </tbody>
                            </table>
                          </div>
                          <div className="coverage__row">
                            <div className="coverage__effective-date">
                              {
                                handleGetInsuredDateInfo()
                              }
                            </div>
                            <div className="coverage__premium">
                              <p>{`優惠保費合計：NT$ ${commonService.thousandFormat(`${commonService.getVehiclePrenium(this.props.tempSelect.tempSelectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, this.props.tempSelect.tempSelectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI)}`)}`}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {/* 保險車籍資料 */}
                  {
                    this.props.tempVehicleOwnerInfo && this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue &&
                    this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState && this.props.tempVehicleInfo &&
                    this.props.tempVehicleInfo.tempVehicleInfoFormValue && this.props.tempVehicleInfo.tempVehicleInfoState &&
                    this.props.tempSelect && this.props.tempSelect.tempSelectFormValue && this.props.tempSelect.tempSelectState &&
                    (
                      <div className="ins-vehicle-info">
                        <div className="ins-vehicle-info__title">保險車籍資料</div>
                        <div className="ins-vehicle-info__content">
                          <div className="element__list">
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">車牌號碼</div>
                                <div className="element__list-group-content">{`${this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`}</div>
                              </div>
                            </div>
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">車輛種類</div>
                                <div className="element__list-group-content">{this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.VEHICLE_TYPE_NAME}</div>
                              </div>
                            </div>
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">引擎號碼/車身號碼</div>
                                <div className="element__list-group-content">
                                  {
                                    this.props.tempSelect.tempSelectFormValue.ENGINE_NUMBER && this.props.tempSelect.tempSelectFormValue.VEHICAL_BODY_NUMBER
                                      ? `${this.props.tempSelect.tempSelectFormValue.ENGINE_NUMBER}/${this.props.tempSelect.tempSelectFormValue.VEHICAL_BODY_NUMBER}`
                                      : this.props.tempSelect.tempSelectFormValue.ENGINE_NUMBER
                                        ? this.props.tempSelect.tempSelectFormValue.ENGINE_NUMBER
                                        : this.props.tempSelect.tempSelectFormValue.VEHICAL_BODY_NUMBER
                                          ? this.props.tempSelect.tempSelectFormValue.VEHICAL_BODY_NUMBER
                                          : ''
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">排氣量或馬力</div>
                                <div className="element__list-group-content">{`${this.props.tempVehicleInfo.tempVehicleInfoFormValue.ENGINE_DISPLACEMENT}${commonService.getSysOptText(this.props.tempVehicleInfo.tempVehicleInfoState.vehiclePowerSysOpts, this.props.tempVehicleInfo.tempVehicleInfoFormValue.ENGINE_DISPLACEMENT_UNIT)}`}</div>
                              </div>
                            </div>
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">製造年月</div>
                                <div className="element__list-group-content">{moment(this.props.tempVehicleInfo.tempVehicleInfoFormValue.MANUFACTUR_YEAR_MONTH).format('YYYY年MM月')}</div>
                              </div>
                            </div>
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">原始發照日期</div>
                                <div className="element__list-group-content">
                                  {`${this.props.tempVehicleInfo.tempVehicleInfoFormValue.ORIGINAL_DATE_YEAR}年${this.props.tempVehicleInfo.tempVehicleInfoFormValue.ORIGINAL_DATE_MONTH}月${this.props.tempVehicleInfo.tempVehicleInfoFormValue.ORIGINAL_DATE_DATE}日`}
                                </div>
                              </div>
                            </div>
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">車輛廠牌</div>
                                <div className="element__list-group-content">{this.props.tempVehicleInfo.tempVehicleInfoFormValue.VEHICAL_MAKER}</div>
                              </div>
                            </div>
                            <div className="element__list-col">
                              <div className="element__list-group">
                                <div className="element__list-group-title">車型</div>
                                <div className="element__list-group-content">{this.props.tempVehicleInfo.tempVehicleInfoFormValue.VEHICAL_MODEL_NAME}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {
                    this.props.tempFill && this.props.tempFill.tempFillFormValue && this.props.tempFill.tempFillState && (
                      <>
                        {/* 被保險人資料(車主) */}
                        <div className="vehical-owner-info">
                          <div className="vehical-owner-info__title">被保險人資料(車主)</div>
                          <div className="vehical-owner-info-content">
                            <div className="element__list">
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">被保險人姓名</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.INSURED_NAME}
                                  </div>
                                </div>
                              </div>
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">{handleGetMemberIdType(this.props.tempFill.tempFillFormValue.INSURED_NATIONALITY_TYPE)}</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.INSURED_MEMBER_ID}
                                  </div>
                                </div>
                              </div>
                              {
                                this.props.tempFill.tempFillFormValue.INSURED_NATIONALITY_TYPE !== NationalType.Legal && (
                                  <div className="element__list-col">
                                    <div className="element__list-group">
                                      <div className="element__list-group-title">{handleGetBirthdayType(this.props.tempFill.tempFillFormValue.INSURED_NATIONALITY_TYPE)}</div>
                                      <div className="element__list-group-content">
                                        {moment(this.props.tempFill.tempFillFormValue.INSURED_BIRTHDAY).format('YYYY年MM月DD日')}
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                this.props.tempFill.tempFillFormValue.INSURED_NATIONALITY_TYPE !== NationalType.Legal && (
                                  <div className="element__list-col">
                                    <div className="element__list-group">
                                      <div className="element__list-group-title">婚姻狀況</div>
                                      <div className="element__list-group-content">
                                        {
                                          this.props.tempFill.tempFillFormValue.INSURED_MARRIAGE === Marriage.Married
                                            ? '已婚'
                                            : this.props.tempFill.tempFillFormValue.INSURED_MARRIAGE === Marriage.Single
                                              ? '未婚'
                                              : ''
                                        }
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">手機號碼</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.INSURED_MOBILE}
                                  </div>
                                </div>
                              </div>
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">電子信箱</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.INSURED_EMAIL}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* 要保人資料 */}
                        <div className="policyholder-info">
                          <div className="policyholder-info__title">要保險人資料</div>
                          <div className="policyholder-info-content">
                            <div className="element__list">
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">要保人姓名</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.POLICYHOLDER_NAME}
                                  </div>
                                </div>
                              </div>
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">{handleGetMemberIdType(this.props.tempFill.tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE)}</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.POLICYHOLDER_MEMBER_ID}
                                  </div>
                                </div>
                              </div>
                              {
                                this.props.tempFill.tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                                  <div className="element__list-col">
                                    <div className="element__list-group">
                                      <div className="element__list-group-title">{handleGetBirthdayType(this.props.tempFill.tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE)}</div>
                                      <div className="element__list-group-content">
                                        {moment(this.props.tempFill.tempFillFormValue.POLICYHOLDER_BIRTHDAY).format('YYYY年MM月DD日')}
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                this.props.tempFill.tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                                  <div className="element__list-col">
                                    <div className="element__list-group">
                                      <div className="element__list-group-title">婚姻狀況</div>
                                      <div className="element__list-group-content">
                                        {
                                          this.props.tempFill.tempFillFormValue.POLICYHOLDER_MARRIAGE === Marriage.Married
                                            ? '已婚'
                                            : this.props.tempFill.tempFillFormValue.POLICYHOLDER_MARRIAGE === Marriage.Single
                                              ? '未婚'
                                              : ''
                                        }
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">手機號碼</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.POLICYHOLDER_MOBILE}
                                  </div>
                                </div>
                              </div>
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">電子信箱</div>
                                  <div className="element__list-group-content">
                                    {this.props.tempFill.tempFillFormValue.POLICYHOLDER_EMAIL}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* 保單寄送方式 */}
                        <div className="delivery">
                          <div className="delivery__title">保單寄送方式</div>
                          <div className="delivery__content">
                            <div className="element__list">
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">保單寄送方式</div>
                                  <div className="element__list-group-content">
                                    {commonService.getSysOptText(this.props.tempFill.tempFillState.policyDeliverySysOpts, this.props.tempFill.tempFillFormValue.DELIVERY)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  }
                  {/*
                    this.state.docLinks && this.state.docLinks.length > 0 && (
                      <>
                        <div className="insure-process-preview__terms-desc">
                          <p>請審閱並勾選以下條款，並點選「我已審閱並同意」進行下一步。</p>
                        </div>
                        <FieldArray name="CONTRACTS">
                          {
                            () => (
                              <>
                                {
                                  this.state.docLinks && this.state.docLinks.length > 0 && values.CONTRACTS && (
                                    <Accordion>
                                      {this.state.docLinks.map((docLink: Link, index: number) => (
                                        <Accordion.Item
                                          key={index}
                                          updateStatus={(openVal: any) => {
                                            // 更新條款狀態
                                            this.setState({
                                              termStatus: commonService.headerClickUpdateTermStatus(openVal, index, this.state.termStatus)
                                            });
                                          }}
                                          isActive={index !== (this.state.docLinks.length - 1) && commonService.setPDFOpen(index, this.state.termStatus)}
                                        >
                                          {docLink.URL.includes('.pdf') ? (
                                            <Accordion.Header title={docLink.NAME}>
                                              <button
                                                type="button"
                                                className="insure-process-preview__terms-download-btn"
                                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleDownloadFile(event, docLink.URL, docLink.NAME)}
                                              />
                                            </Accordion.Header>
                                          ) : (
                                            <Accordion.Header title={docLink.NAME} link={docLink.URL} />
                                          )}
                                          <Accordion.Content>
                                            {docLink.URL.includes('.pdf') && (
                                              <PDFViewer title={docLink.NAME} fileUrl={docLink.URL} />
                                            )}
                                          </Accordion.Content>
                                          <Accordion.Addition>
                                            <div className="element__checkbox-group">
                                              <label htmlFor={`contract-checkbox-${index + 1}`}>
                                                <div className="element__checkbox">
                                                  <Field
                                                    type="checkbox"
                                                    name={`CONTRACTS[${index}].CONTRACT`}
                                                    id={`contract-checkbox-${index + 1}`}
                                                    onClick={(event: React.MouseEvent<HTMLInputElement>) => this.setContractCheckedTimeFieldValue(event, index)}
                                                  />
                                                  <div className="element__checkbox-btn" />
                                                </div>
                                                <span>審閱條款</span>
                                              </label>
                                            </div>
                                          </Accordion.Addition>
                                        </Accordion.Item>
                                      ))}
                                    </Accordion>
                                  )
                                }
                              </>
                            )
                          }
                        </FieldArray>
                      </>
                    )
                  */}
                  {/* <div className="insure-process-preview__terms">
                    <div className="element__checkbox-group">
                      <label htmlFor='all-checked-checkbox'>
                        <div className="element__checkbox">
                          <Field
                            type="checkbox"
                            name="ALL_CONTRACT_CHECKED"
                            id='all-checked-checkbox'
                            disabled={_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT)}
                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                              e.currentTarget.checked
                                ? apiCommonService.fetchSysTime().then((res: any) => {
                                  setFieldValue(`ALL_CONTRACT_CHECKED_TIME`, res)
                                })
                                : setFieldValue(`ALL_CONTRACT_CHECKED_TIME`, null);
                              if (e.currentTarget.checked) {
                                // 重置已展開的條款
                                this.setState({
                                  termStatus: commonService.resetTermStatus(this.state.termStatus)
                                });
                              }
                            }}
                          />
                          <div className="element__checkbox-btn" />
                        </div>
                        <span>我已審閱及同意上述條款</span>
                      </label>
                    </div>
                  </div> */}
                </div>
                <div className="insure-process-preview__controls">
                  <button type="button" className="element__button element__button--red-border" onClick={() => this.props.onGoBack(values, this.state)}>返回上一頁</button>
                  <button
                    type="submit"
                    className="element__button element__button--red"
                    // disabled={_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT) || !values.ALL_CONTRACT_CHECKED}
                  >
                    下一步
                  </button>
                </div>
              </Form>
            )
          }
        </Formik>
      </div>
    );
  }
}

export default InsureProcessPreview;
